export const servicesData = [
  {
    id: 1,
    icon: "uil uil-store",
    titleLine1: "Shopify App",
    titleLine2: "Development",
    title: "Shopify App Development",
    description: "5+ years building custom Shopify apps, Liquid themes, and eCommerce integrations for merchants worldwide.",
    bullets: [
      "Custom Shopify app development using Remix and App Bridge.",
      "Admin API & Storefront API integration (GraphQL & REST).",
      "Shopify Functions for discounts, checkout validation, and delivery.",
      "Liquid theme development and App Block customization.",
      "POS app development and Webhook implementation.",
    ],
  },
  {
    id: 2,
    icon: "uil uil-layer-group",
    titleLine1: "Full-Stack",
    titleLine2: "Web Development",
    title: "Full-Stack Web Development",
    description: "End-to-end web application development with PHP/Laravel backends and React frontends, serving SaaS and B2B clients.",
    bullets: [
      "SaaS platform architecture with Laravel and PHP.",
      "React and Node.js frontend and API development.",
      "Database design with MySQL and Eloquent ORM / Prisma.",
      "Multi-tenant application architecture and role-based access control.",
      "Agile delivery with CI/CD, GitHub, and team collaboration tools.",
    ],
  },
  {
    id: 3,
    icon: "uil uil-exchange",
    titleLine1: "API Design &",
    titleLine2: "Integration",
    title: "API Design & Integration",
    description: "Designing and integrating scalable REST and GraphQL APIs, connecting your platform with third-party services.",
    bullets: [
      "RESTful API design, documentation, and versioning.",
      "GraphQL schema design and resolver implementation.",
      "Third-party service integration (payment gateways, shipping, ERP).",
      "Webhook systems for real-time event-driven communication.",
      "Secure API authentication using OAuth2 and token-based flows.",
    ],
  },
];
